<script setup lang="ts">
// TODO: Размер lg удалить когда детальная страница товара будет с новым дизайном
type Size = 'sm' | 'md' | 'lg'

type Props = {
  size: Size
  backgroundColor?: string
}

const props = defineProps<Props>()

const componentClasses = computed(() => {
  return [`product-card-tag--size-${props.size}`]
})

const componentStyles = computed(() => {
  return {
    backgroundColor: props.backgroundColor,
  }
})
</script>

<template>
  <div
    class="product-card-tag"
    :class="componentClasses"
    :style="componentStyles"
  >
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.product-card-tag {
  display: flex;
  align-items: center;
  text-align: center;
  border-radius: 50px;
}

.product-card-tag--size-sm {
  gap: 2px;
  padding: 2px 4px;
  font-size: 8px;
  font-weight: 700;
  line-height: 10px;

  @include media('>=desktop-mini') {
    padding-right: 8px;
    padding-left: 8px;
    font-size: 12px;
    font-weight: 800;
    line-height: 16px;
  }
}

.product-card-tag--size-md {
  gap: 4px;
  padding: 4px 8px;
  font-size: 12px;
  font-weight: 800;
  line-height: 16px;
}

.product-card-tag--size-lg {
  gap: 4px;
  padding: 6px 8px;
  font-size: 16px;
  font-weight: 800;
  line-height: 20px;
}
</style>
